const BUTTON_SELECTOR = '.js-popover-opener';
const ACTIVE_CLASS = 'active';

const popoverOpenerElements = document.querySelectorAll<HTMLButtonElement>(BUTTON_SELECTOR);

function toggle(buttonElement: HTMLButtonElement) {
  const popoverContentId = buttonElement.getAttribute('aria-controls');
  const contentElement = document.querySelector<HTMLElement>(`#${popoverContentId}`);

  if (!contentElement)
    return;

  function close() {
    buttonElement.setAttribute('aria-expanded', 'false');
    contentElement?.classList.remove(ACTIVE_CLASS);
  }

  function open() {
    buttonElement.setAttribute('aria-expanded', 'true');
    contentElement?.classList.add(ACTIVE_CLASS);
  }

  function handleOutsideClick(event: Event) {
    const target = event.target as HTMLElement;
    const isPopoverAriaClick = !!(target.closest(BUTTON_SELECTOR)) || !!(target.closest(`#${popoverContentId}`));
    if (!isPopoverAriaClick) {
      close();
      document.removeEventListener('click', handleOutsideClick);
    }
  }

  if (buttonElement.getAttribute('aria-expanded') === 'false') {
    open();
    document.addEventListener('click', handleOutsideClick);
  }
  else {
    close();
    document.removeEventListener('click', handleOutsideClick);
  }
}
export function initPopovers() {
  for (const buttonElement of popoverOpenerElements) {
    buttonElement.addEventListener('click', () => {
      toggle(buttonElement);
    });
  }
}
